<template>
  <q-dialog v-model="dialog" persistent>
    <div class="hris-modal hris-modal-lg" style="max-width: 980px; width: 100%;">
      <div class="hris-modal-header">
        <div>
          <h2 class="hris-modal-title">Merits &amp; Demerits</h2>
          <p class="hris-modal-subtitle">{{ fullname }}</p>
        </div>
        <q-btn flat dense round v-close-popup class="hris-q-ghost" aria-label="Close">
          <i class="fas fa-times"></i>
        </q-btn>
      </div>
      <div class="hris-modal-body">
        <q-form ref="vForm" @submit="onSubmit">
          <div class="row q-col-gutter-md">
            <div class="col-12 col-md-4">
              <div class="hris-form-section" style="margin-bottom: 0;">
                <div class="hris-form-section-title">Add Record</div>
                <div class="q-gutter-md">
                  <q-select outlined dense color="green" v-model="type" option-value="val" :rules="[formRules.required]" option-label="name" :options="typeOptions" label="Type" emit-value map-options></q-select>
                  <q-input outlined dense color="green" v-model="title" label="Title" :rules="[formRules.required]"></q-input>
                  <q-input outlined dense color="green" v-model="description" label="Description" :rules="[formRules.required]"></q-input>
                  <q-input outlined dense color="green" v-model="date" mask="date" :rules="['date']" label="Date">
                    <template v-slot:append>
                      <i class="far fa-calendar-alt cursor-pointer">
                        <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                          <q-date v-model="date" @input="() => $refs.qDateProxy.hide()"></q-date>
                        </q-popup-proxy>
                      </i>
                    </template>
                  </q-input>
                  <q-btn unelevated class="hris-q-primary full-width" type="submit" label="Save"></q-btn>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-8">
              <div class="hris-panel" style="margin-bottom: 0;">
                <div class="hris-panel-title">Record History</div>
                <q-table flat :data="merits" :columns="columns" row-key="id">
                  <template v-slot:body="props">
                    <q-tr :props="props" @click="selectedRow(props)" style="cursor: pointer;">
                      <q-td key="types" :props="props">{{ props.row.types }}</q-td>
                      <q-td key="title" :props="props">{{ props.row.title }}</q-td>
                      <q-td key="description" :props="props">{{ props.row.description }}</q-td>
                      <q-td key="date_added" :props="props">{{ props.row.date_added }}</q-td>
                      <q-td key="updateby" :props="props">{{ props.row.updateby }}</q-td>
                    </q-tr>
                  </template>
                  <template v-slot:no-data="">
                    <div class="hris-empty full-width">No merit or demerit records found.</div>
                  </template>
                </q-table>
              </div>
            </div>
          </div>
        </q-form>
      </div>
    </div>
  </q-dialog>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

  data() {
    return {
      empID:0,
      dialog:false,
	  fullname:null,
	  type:null,
	  title:null,
	  description:null,
	  date:null,
      columns: [
      { name: 'types', align: 'center', label: 'Type', field: 'types', sortable: true },
      { name: 'title', align: 'center', label: 'Title', field: 'title', sortable: true },
      { name: 'description', label: 'Description', field: 'description', sortable: true },
      { name: 'date_added', label: 'Date', field: 'date_added' , sortable: true},
      { name: 'updateby', label: 'Update By', field: 'updateby' , sortable: true},
      ],
      merits: [],
	  typeOptions:[
	  {val:1,name:'TRAININGS AND SEMINARS'},
	  {val:2,name:'AWARD AND RECOGNITION'},
	  {val:3,name:'SPECIAL PROJECTS'},
	  {val:4,name:'MEMOS/DEVIATIONS'},
	  ],
    }
  },
  created(){
    this.eventHub.$on('meritsUpdate', this.meritsUpdate);
  },

  methods: {

    meritsUpdate:function(payload){
       this.fullname = payload.employee.row.firstname + ' ' + payload.employee.row.lastname + '' + ' Records'
       this.empID = payload.employee.row.id
       this.dialog = payload.stat
      this.getAwardUpdate(this.empID)
    },

    selectedRow:function(emp){
     this.cardtype = emp.row.cardtype
     this.cardNo = emp.row.new
   },


   onSubmit:function(){
    let formData = new FormData();

    formData.append("empID", this.empID);
    formData.append("type", this.type);
    formData.append("title", this.title);
	formData.append("description", this.description);
	formData.append("date", this.date);
    formData.append("updateby", this.userData.username);

    axios.create({
      baseURL : this.apiUrl,
      headers : {'Authorization' : `Bearer ${this.token}`}
    }).post('/admin/employee/award',formData)
    .then((res) => {
		this.$q.notify({
				message: res.data.data,
				color: (res.data.status) ? 'green' : 'red',
				position:'center',
				actions: [{ label: 'Dismiss', color: 'white', handler: () => {} }]
		})
      this.getAwardUpdate(this.empID)
      	this.type = ''
      	this.title = ''
	   	this.description = ''
	   	this.date = ''
      	this.$refs.vForm.reset()
    });
  },

  getAwardUpdate: function(empID) {
    axios.create({
      baseURL: this.apiUrl,
      headers: {
        'Authorization': `Bearer ${this.token}`
      }})
    .get(`/admin/employee/award/${empID}`)
    .then((res) => {
      this.merits = res.data.data;
      setTimeout(() => {
        this.spinner = false
      },500)
    })

  },

  closeModal:function(){
    this.career = false
  },
}
}
</script>
<style lang="css" scoped>
</style>
